import { render, staticRenderFns } from "./view-enquiry.vue?vue&type=template&id=5874c26f&"
import script from "./view-enquiry.vue?vue&type=script&lang=ts&"
export * from "./view-enquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports